<template></template>

<script setup>
// catalogue page does not exist (yet)
clearError({ redirect: '/' });
</script>

<style lang="scss" scoped></style>
